import {
  ContractDto,
  ContractFullReferenceDto,
  ContractReferenceDto,
} from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type ContractDtoAny = ContractDto | ContractReferenceDto | ContractFullReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type ContractDtoAll = ContractDto & ContractReferenceDto & ContractFullReferenceDto;

export class ContractMapper {}
